import React, { Component } from 'react';
import { post } from 'axios';

export class UploadFile extends Component {
  static displayName = UploadFile.name;

  constructor (props) {
    super(props);
    this.state = {
      forecasts: [],
      loading: true,
      file: null,
    };
  }

  static renderUploadedFileInfo (uploadedFile) {
    const fileUrl = window.location.origin + '/api/file/' + uploadedFile.fileUrl;
    return (
      <p><a href={fileUrl}>{fileUrl}</a></p>
    );
  }

  async submit(e) {
    e.preventDefault();

    const url = '/api/file';
    const formData = new FormData();
    formData.append('body', this.state.file);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      }
    }
    return post(url, formData, config).then(data => {
      this.setState({uploadedFile:data.data, loading: false});
    });
  }

  uploadFile(e) {
    this.setState({ file: e.target.files[0] });
  }

  render () {
    let uploadedFile = !this.state.uploadedFile
      ? <p></p>
      : UploadFile.renderUploadedFileInfo(this.state.uploadedFile);

    return (
      <div>
        <h1>File Upload</h1>
        <form onSubmit={e => this.submit(e)}>
          <input type="file" onChange={e => this.uploadFile(e)} />
          <button type="submit">Upload</button>
        </form>
        {uploadedFile}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UploadFile.js